export default __webpack_public_path__ + "static/media/jpg.c51fe76a.svg";